// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3UJ5n","colMin":"styles_colMin__20oKy","colCheckbox":"styles_colCheckbox__PopvL"};